var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13.4 13.4",
    height: "13.4mm",
    width: "13.4mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "outerRingGradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ececec"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "innerRingGradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c9c9c9"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ledLinearGradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "specularGradient",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97.007398,-129.81573)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 6.6999998,
    cx: 103.7074,
    cy: 136.51573,
    style: {
      fill: "url(#outerRingGradient)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6,
    cx: 103.71667,
    cy: 136.52499,
    style: {
      fill: "url(#innerRingGradient)"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5.2916665,
    cx: 103.71667,
    cy: 136.52499,
    className: "led-colour"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 5.2916665,
    cx: 103.71667,
    cy: 136.52499,
    style: {
      fill: "url(#ledLinearGradient)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.2333331,
    ry: 3.3261905,
    cx: 103.71667,
    cy: 134.78819,
    style: {
      fill: "url(#specularGradient)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLed);
export default __webpack_public_path__ + "static/media/led.b163fb22454d21c21b4e112d01e1a987.svg";
export { ForwardRef as ReactComponent };